<template>
  <v-dialog v-model="dialog" :max-width="1264" persistent>
    <v-card>
      <v-card-title class="py-2">
        <v-toolbar-title>Transaction Details</v-toolbar-title>
        <v-spacer />
        <v-btn variant="text" :icon="mdiClose" class="ma-0" @click="close()" />
      </v-card-title>

      <v-card-text>
        <v-data-table
          v-model:options="pagination"
          :headers="tableHeaders"
          :items="tableItems"
          :items-per-page-options="[10, 25, 50, 100]"
          :loading="loading"
          :no-data-text="loading ? 'Loading...' : 'No data found.'"
          must-sort
        >
          <template #item="{ item }">
            <tr>
              <td>
                <a :href="`/filing/${item.permalink}`" target="_blank">
                  {{ item.transaction_date }}
                </a>
              </td>
              <td>{{ item.acceptance_date }}</td>
              <td>{{ item.acquired_disposed }}</td>
              <td>{{ item.symbol }} {{ item.stock_title }}</td>
              <td>{{ item.filer_name }}</td>
              <td>{{ item.officer_title }}</td>
              <td>{{ whole_number(item.shares_owned_after_transaction) }}</td>
              <td>{{ whole_number(item.transaction_shares) }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { useUserStore, useAppStore, useWwStore } from '@/store'
// Modules
import api from '@/store/api'

// Mixins
import FormattersMixin from '@/mixins/formatters'
import { mdiClose } from '@mdi/js'

export default {
  mixins: [FormattersMixin],

  data() {
    return {
      mdiClose,
      dialog: false,
      loading: false,
      tableHeaders: [
        { title: 'Transaction Date', key: 'transaction_date' },
        { title: 'Filing Date', key: 'acceptance_date' },
        { title: 'A/D', key: 'acquired_disposed' },
        { title: 'Ticker', key: 'symbol' },
        { title: 'Filer', key: 'filer_name' },
        { title: 'Title', key: 'officer_title' },
        { title: 'Shares Owned After (split-adjusted)', key: 'shares_owned_after_transaction' },
        { title: 'Shares Traded (split-adjusted)', key: 'transaction_shares' }
        /* { text: 'Transaction Cost', value: 'transaction_amount' },
        { text: 'PPS', value: 'transaction_price_per_share' },
        { text: 'Total Shares Owned', value: 'direct_and_indirect_shares_owned' }*/
      ],
      tableItems: [],
      pagination: {
        sortBy: [{ key: 'transaction_date', order: 'desc' }],
        page: 1,
        itemsPerPage: 10
      }
    }
  },

  methods: {
    showDetails(item, criteria) {
      this.dialog = true
      this.loading = true

      api
        .post('insider_transactions', { item, criteria })
        .then(response => {
          this.tableItems = response.data
        })
        .catch(error => {
          useAppStore().showNotification({
            type: 'error',
            text: (error.response && error.response.data) || error.message
          })
        })
        .then(() => (this.loading = false))
    },

    close() {
      this.dialog = false
      this.tableItems = []
    }
  }
}
</script>
